export default function HintIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect
        x="3"
        y="3"
        width="18"
        height="18"
        rx="9"
        fill="#C0C2BE"
        fillOpacity="0.5"
      />
      <path
        d="M10 10V9C10 8.44772 10.4477 8 11 8H13C13.5523 8 14 8.44772 14 9V10.382C14 10.7607 13.786 11.107 13.4472 11.2764L12.5528 11.7236C12.214 11.893 12 12.2393 12 12.618V13"
        stroke="white"
        strokeWidth="2"
      />
      <path d="M12 15L12 17" stroke="white" strokeWidth="2" />
    </svg>
  );
}
